import React, { useEffect, useState } from "react";
import AppStoreBtn from "../assets/images/app-store-btn.png";
import GooglePlayBtn from "../assets/images/google-play-btn.png";
import ACTLogoWhite from "../assets/images/ACT-Logo-White.png";
import { Box, Link, Typography, useMediaQuery, useTheme } from "@mui/material";

const goToActVerify = () => {
  window.open("https://act-verify.advancedcompliance.tech/", "_blank", "noopener,noreferrer");
};

const goToAppStore = () => {
  window.open("https://www.apple.com/uk/app-store/", "_blank", "noopener,noreferrer");
};

const goToGooglePlay = () => {
  window.open("https://play.google.com/store/apps", "_blank", "noopener,noreferrer");
};

const StoreLinksPanel = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        background: "rgb(0,0,0)",
        background:
          "linear-gradient(180deg, rgba(0,0,0,1) 0%, #b33b78 70%, #E54F9C 100%)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "0.6rem 0 0.6rem 0",
        borderRadius: "0.5rem",
        width: isMobile ? "90%" : "20rem",
        margin: isMobile ? "0.25rem auto 0 auto" : "1rem auto 0 auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end",
          gap: "0.3rem",
        }}
      >
        <Typography
          sx={{
            color: "#ffffff",
            textAlign: "center",
            fontSize: "0.9rem",
            fontWeight: "700",
            lineHeight: "1.2",
            margin: "0",
          }}
        >
          Download
        </Typography>
        <img
          src={ACTLogoWhite}
          alt="ACT Logo"
          style={{
            width: "3.2rem",
            height: "auto",
            marginBottom: "0.2rem",
            imageRendering: "crisp-edges",
          }}
        />
        <Typography
        sx={{
          color: "#ffffff",
          textAlign: "center",
          fontSize: "0.9rem",
          fontWeight: "700",
          lineHeight: "1.3",
          margin: "0",
        }}
      >
        to{" "}
        <span
          style={{
            color: "#E54F9C",
          }}
        >
          verify
        </span>{" "}
        your location
      </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: "1rem",
          margin: "0.5rem 0 0.3rem 0",
        }}
      >
        <button onClick={goToAppStore}>
          <img
            src={AppStoreBtn}
            alt="App Store"
            style={{
              width: isMobile ? "8rem" : "8.25rem",
              height: "auto",
              imageRendering: "crisp-edges",
              cursor: "pointer",
            }}
          />
        </button>
        <button onClick={goToGooglePlay}>
          <img
            src={GooglePlayBtn}
            alt="App Store"
            style={{
              width: isMobile ? "8rem" : "8.25rem",
              height: "auto",
              imageRendering: "crisp-edges",
              cursor: "pointer",
            }}
          />
        </button>
      </Box>
      <Typography
        sx={{
          color: "#ffffff",
          textAlign: "center",
          fontSize: "0.68rem",
          fontWeight: "600",
          lineHeight: "1.2",
          margin: "0 0 0.1rem 0",
        }}
      >
        For more information please visit
        <button
          onClick={goToActVerify}
          style={{
            textDecoration: "underline",
            marginLeft: "0.25rem",
            cursor: "pointer",
          }}
        >
          www.act-verify.advancedcompliance.tech
        </button>
      </Typography>
    </Box>
  );
};

export default StoreLinksPanel;
